export const getFilenameFromHeaders = headers => {
  const disposition = headers['content-disposition']
  const match = disposition.match(/filename="?([^";]+)"?/)

  return match[1]
}

export const triggerDownload = ({ blob, filename }) => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = filename
  anchor.click()

  URL.revokeObjectURL(url)
}
